<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                            <p>
                                Dónde se perdió una venta y por qué.
                                Identifica si faltó stock, hubo precio
                                fuera, visita fallida u otro motivo.
                                Úsalo para corregir causas y recuperar oportunidades.
                            </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Venta Perdida
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Ayuda a identificar en cada proceso configurado dentro de AVE la cantidad solicitada versus la
                    atendida por <b>material</b> y <b>socio de negocio</b>.
                </div>
            </div>
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                </div>
                <!-- Actions -->
                <div
                    class="mt-6 flex flex-col sm:flex-row shrink-0 sm:items-center space-y-3 sm:space-y-0 sm:space-x-3 sm:ml-4 sm:mt-0">
                    <span>Selección multiple</span>
                    <mat-form-field class="min-w-64" floatLabel="never">
                        <mat-select [(ngModel)]="selectLostSale" [ngModelOptions]="{standalone: true}"
                            placeholer="Selecciona una o varias opciones" multiple>
                            @for (ls of listLostSale; track ls) {
                            <mat-option [value]="ls.code">
                                {{ ls.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <ng-container *ngIf="hasData()">
                        <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
                            (click)="onExportResumeButtonPressed()" matTooltip="Exportar">
                            <mat-icon class="icon-size-5"
                                [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                            <span class="ml-2">Exportar</span>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">

            <!-- Main Content (Table and Paginator) -->
            <div class="flex flex-auto flex-col overflow-auto">
                <!-- Tabla -->
                <div class="container mt-0 flex-auto flex-col">
                    <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)" style="height: 100%">
                        <mat-tab *ngIf="selectLostSale.includes('COMERCIAL')" label="Venta Perdida Comercial">
                            <app-smart-grid
                                [data]="dataSourceC.data"
                                [columnDefs]="columnDefsCommercial"
                                [config]="gridConfigCommercial"
                                [loading]="isLoading()"
                                [totalRecords]="totalItems"
                                [detailTemplate]="rowDetailsTemplate"
                                (pageChanged)="onPageChangeCommercial($event)"
                                (sortChanged)="onSortChangeCommercial($event)">
                            </app-smart-grid>
                        </mat-tab>
                        <mat-tab *ngIf="selectLostSale.includes('LOGISTICA')" label="Venta Perdida Logística">
                            <app-smart-grid
                                [data]="dataSourceL.data"
                                [columnDefs]="columnDefsLogistic"
                                [config]="gridConfigLogistic"
                                [loading]="isLoading()"
                                [totalRecords]="totalItems"
                                (pageChanged)="onPageChangeCommercial($event)"
                                (sortChanged)="onSortChangeCommercial($event)">
                            </app-smart-grid>
                        </mat-tab>
                        <mat-tab *ngIf="selectLostSale.includes('ENTREGA')" label="Venta Perdida Real">
                            <app-smart-grid
                                [data]="dataSourceE.data"
                                [columnDefs]="columnDefsReal"
                                [config]="gridConfigReal"
                                [loading]="isLoading()"
                                [totalRecords]="totalItems"
                                (pageChanged)="onPageChangeCommercial($event)"
                                (sortChanged)="onSortChangeCommercial($event)">
                            </app-smart-grid>
                        </mat-tab>
                        <mat-tab *ngIf="selectLostSale.includes('RESUMEN')" label="Resumen">
                            <app-smart-grid
                                [data]="dataSourceR.data"
                                [columnDefs]="columnDefsResume"
                                [config]="gridConfigResume"
                                [loading]="isLoading()"
                                [totalRecords]="totalItems"
                                (pageChanged)="onPageChangeCommercial($event)"
                                (sortChanged)="onSortChangeCommercial($event)">
                            </app-smart-grid>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </div>
    <!-- Modales -->
    <ng-template #rowDetailsTemplate let-order>
        <div class="overflow-hidden">
            <div class="flex border-b">
                <form class="flex w-full flex-col">
                    <div class="flex flex-col py-6 px-13 sm:flex-row">
                        <div class="flex flex-auto flex-wrap">
                            <div class="p-2 flex w-full flex-col">

                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </ng-template>

    <ng-template #noData>
        <span>
            -
        </span>
    </ng-template>

    <!-- Filtros -->
    <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()" (onPanelOpened)="onFilterPanelOpened()">
        <app-dates-filters [form]="form" [showDateCreationRange]="true" [showUploadDateRange]="true"></app-dates-filters>
        <app-configuration-filters [form]="form" [company]="true"
            [loadData]="loadFiltersData"></app-configuration-filters>
        <app-routes-filters [form]="form" [route]="true" [loadData]="loadFiltersData"></app-routes-filters>
        <app-business-partners-filters [form]="form" [assignedUser]="true" [businessPartner]="true"
            [loadData]="loadFiltersData"></app-business-partners-filters>
        <app-materials-management-filters [form]="form" [materialGroup]="true" [material]="true" [isMultiple]="true"
            [loadData]="loadFiltersData"></app-materials-management-filters>
    </app-filter>

</mat-sidenav-container>